var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LoadUser',{attrs:{"deletedUserName":_vm.reactiveDeletedUserName},on:{"userInfo":function($event){return _vm.getUserInfo($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }